import React, { useEffect, useRef, memo } from "react";

// Generic loader for TradingView embeddable widgets (official real-time data).
function TradingViewWidget({ scriptSrc, config, className = "", style = {} }) {
  const containerRef = useRef(null);
  const configKey = JSON.stringify(config);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = "";

    const widgetDiv = document.createElement("div");
    widgetDiv.className = "tradingview-widget-container__widget";
    container.appendChild(widgetDiv);

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = configKey;
    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [scriptSrc, configKey]);

  return (
    <div className={`tradingview-widget-container ${className}`} ref={containerRef} style={style} />
  );
}

export default memo(TradingViewWidget);
